//import { useState } from 'react';
import {
    Container,
    Title,
    BodyText,
    CenterContainer,
    LinkText,
    CardIconContainer,
    Image
} from './styles/ServiceCardStyles';
import CommunicationsIcons from '../../../../assets/icons/CommunicationsIcons.png'
import DesarrolloIcon from '../../../../assets/icons/DesarrolloIcon.png'
import EnergyIcons from '../../../../assets/icons/EnergyIcons.png'
import FlyIcon from '../../../../assets/icons/FlyIcon.png'
import InvestIcon from '../../../../assets/icons/InvestIcon.png'
import iconsProfitIcon  from '../../../../assets/icons/icons8-profit.svg'
import InvestCoinIcon from '../../../../assets/icons/icons8-investment-80.png'
function ServiceCard({ title, bodyText, onRequestPress, requestCustomTitle, cardNumber = 0 }) {
    const iconsForCard = [
        FlyIcon,
        EnergyIcons,
        DesarrolloIcon,
        CommunicationsIcons,
        InvestIcon,
        iconsProfitIcon,
        InvestCoinIcon
    ]
    return (
        <Container>
            <CardIconContainer>
                <Image src={iconsForCard[cardNumber]} />
            </CardIconContainer>
            <CenterContainer >
                <Title>{title}</Title>
                <BodyText>
                    {bodyText}
                </BodyText>
                <LinkText onClick={onRequestPress}>
                    {requestCustomTitle ? requestCustomTitle : "VER TRÁMITES"}
                </LinkText>
            </CenterContainer>
        </Container >
    );
}

export default ServiceCard;
